import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";

// Models
import { JobFunction } from "src/app/contacts/model/jobFunction.model";
import { Salutation } from "src/app/contacts/model/salutation.model";
import { AddressClass } from "src/app/modules/shared/model/addressClass.model";
import { AddressType } from "src/app/modules/shared/model/addressType.model";
import { Country } from "src/app/modules/shared/model/country.model";
import { Language } from "src/app/modules/shared/model/language.model";
import { Source } from "src/app/modules/shared/model/source.model";

// Actions
import { beginGetJobFunctions, beginGetSalutations, beginGetAddressClasses, beginGetAddressTypes, beginGetCountries, beginGetLanguages,
    beginGetSources } from "./sharedData.actions";

@Injectable({ providedIn: 'root' })
export class SharedDataService {
    constructor(
        private store: Store<{
            jobFunctions: JobFunction[],
            salutations: Salutation[],
            addressClasses: AddressClass[],
            addressTypes: AddressType[],
            countries: Country[],
            languages: Language[],
            sources: Source[],
        }>) {
    }

    dispatchGettingAllStores(): void {
        this.store.dispatch(beginGetJobFunctions());
        this.store.dispatch(beginGetSalutations());
        this.store.dispatch(beginGetAddressClasses());
        this.store.dispatch(beginGetAddressTypes());
        this.store.dispatch(beginGetCountries());
        this.store.dispatch(beginGetLanguages());
        this.store.dispatch(beginGetSources());
    }

    dispatchGettingAddressTypes(): void {
        this.store.dispatch(beginGetAddressTypes());
    }

    dispatchGettingCountriesList():void{
        this.store.dispatch(beginGetCountries());
    }

    loadJobFunctions(): Observable<JobFunction[]> {
        return this.store.pipe(select('jobFunctions'));
    }

    loadSalutations(): Observable<Salutation[]> {
        return this.store.pipe(select('salutations'));
    }

    loadAddressClasses(): Observable<AddressClass[]> {
        return this.store.pipe(select('addressClasses'));
    }

    loadAddressTypes(): Observable<AddressType[]> {
        return this.store.pipe(select('addressTypes'));
    }

    loadCountries(): Observable<Country[]> {
        return this.store.pipe(select('countries'));
    }

    loadLanguages(): Observable<Language[]> {
        return this.store.pipe(select('languages'));
    }

    loadSources(): Observable<Source[]> {
        return this.store.pipe(select('sources'));
    }
}
